module.exports = __webpack_public_path__ + "static/iphone-top-2155f2a0bd7c4c10e40cf1325da5f8ab.jpg";